(function (global) {
  'use strict';

  const namespace = global.AVAL = global.AVAL || {};
  if (namespace.pricing) {
    global.AVAL_PRICE = namespace.pricing;
    return;
  }

  const HH = Object.freeze({
    lat: 53.56239262,
    lng: 10.02034136
  });

  /*
    Fachliche Tarifversion. Dieser Wert bleibt bewusst stabil, solange sich
    die Preisformel nicht ändert, damit laufende Buchungsentwürfe kompatibel
    bleiben. Die technische Modulversion wird separat geführt.
  */
  const PRICE_LOGIC_VERSION =
    '2026-07-20_step1_pickup_distance_plus_route_v2_exact_reference';

  const MODULE_VERSION = '2026-08-09_pricing-core-v1';
  const P_EXTRA_STOP = 50;
  const EXTRA_KM_BLOCK_KM = 10;
  const EXTRA_KM_BLOCK_PRICE = 10;
  const VIA_TOL = 1.2;

  function normalizeText(value) {
    return String(value ?? '').trim().replace(/\s+/g, ' ');
  }

  function round2(value) {
    const number = Number(value);
    return Number.isFinite(number) ? Math.round(number * 100) / 100 : 0;
  }

  function normalizedKm(value) {
    const km = Number(value);
    return Number.isFinite(km) && km > 0 ? km : 0;
  }

  /*
    Transportstrecke Abholadresse → Zustelladresse:
    0–10 km = 110 €, >10–20 km = 120 €, danach je angefangene 10 km +10 €.
  */
  function priceByDistance(km) {
    const distanceBlocks = Math.max(1, Math.ceil(normalizedKm(km) / 10));
    return 100 + (distanceBlocks * 10);
  }

  /*
    Anfahrt Schottweg → erste Abholadresse:
    0–10 km ohne Aufschlag, danach je angefangene 10 km +10 €.
  */
  function pickupDistanceSurcharge(km) {
    const surchargeBlocks = Math.max(0, Math.ceil(normalizedKm(km) / 10) - 1);
    return surchargeBlocks * 10;
  }

  function calculateBasePrice(params) {
    const AB = normalizedKm(params?.AB);
    const hA = normalizedKm(params?.hA);
    const hB = normalizedKm(params?.hB);
    const pickupInHamburg = params?.pickupInHamburg === true;
    const deliveryInHamburg = params?.deliveryInHamburg === true;
    const cityA = normalizeText(params?.cityA).toLocaleLowerCase('de-DE');
    const cityB = normalizeText(params?.cityB).toLocaleLowerCase('de-DE');

    /* Metadaten für bestehende Auswertungen; ohne Einfluss auf den Preis. */
    const sameCityOutsideHamburg = !!(
      !pickupInHamburg &&
      !deliveryInHamburg &&
      cityA &&
      cityB &&
      cityA === cityB
    );

    const hamburgOnRoute = AB > 0 ? (hA + hB <= VIA_TOL * AB) : false;
    const routePrice = priceByDistance(AB);
    const pickupSurcharge = pickupDistanceSurcharge(hA);

    return Object.freeze({
      routeType: 'PICKUP_DISTANCE_PLUS_ROUTE',
      pricingDistanceKm: AB + hA,
      basePrice: routePrice + pickupSurcharge,
      routePrice,
      pickupSurcharge,
      sameCityOutsideHamburg,
      hamburgOnRoute
    });
  }

  function fmt(value) {
    return round2(value).toFixed(2).replace('.', ',');
  }

  const pricing = Object.freeze({
    HH,
    PRICE_LOGIC_VERSION,
    MODULE_VERSION,
    P_EXTRA_STOP,
    EXTRA_KM_BLOCK_KM,
    EXTRA_KM_BLOCK_PRICE,
    VIA_TOL,
    round2,
    normalizedKm,
    priceByDistance,
    pickupDistanceSurcharge,
    calculateBasePrice,
    fmt
  });

  namespace.pricing = pricing;
  global.AVAL_PRICE = pricing;

  if (typeof module === 'object' && module.exports) module.exports = pricing;
})(typeof window !== 'undefined' ? window : globalThis);
